// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SupportedMediaTypes__list-item-b9a7ec {
  cursor: pointer;
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-110);
  padding: 12px 24px;
  display: flex;
  align-items: center;
}

.SupportedMediaTypes__header-c02235 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.SupportedMediaTypes__header-title-e9120e {
  position: relative;
  flex: 1;
}

.SupportedMediaTypes__header-title-e9120e:after {
  position: absolute;
  content: "";
  width: 1px;
  height: 32px;
  inset-inline-end: 0px;
  top: 50%;
  margin-top: -16px;
  background-color: var(--base-20);
}

.SupportedMediaTypes__header-counter-d84e70 {
  margin-inline-start: 8px;
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  color: var(--base-80);
}

.SupportedMediaTypes__header-icon-fbcce9 {
  fill: var(--base-80);
  transform: rotateX(180deg);
}

.SupportedMediaTypes__header-opened-icon-b9b769 {
  transform: rotateX(0deg);
}

.SupportedMediaTypes__checkbox-b9ed8c {
  margin-inline-end: 24px;
}

.SupportedMediaTypes__header-c02235:hover,
.SupportedMediaTypes__header-c02235:focus-visible,
.SupportedMediaTypes__list-item-b9a7ec:hover,
.SupportedMediaTypes__list-item-b9a7ec:focus-visible {
  background-color: var(--base-17);
}

.SupportedMediaTypes__header-c02235:active .SupportedMediaTypes__list-item-b9a7ec:active {
  background-color: var(--base-20);
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/GroupPermissionsPopup/SupportedMediaTypes/SupportedMediaTypes.styles.m.css"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,wBAAA;EACA,0CAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,OAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,qBAAA;EACA,QAAA;EACA,iBAAA;EACA,gCAAA;AACF;;AAEA;EACE,wBAAA;EACA,wBAAA;EACA,0CAAA;EACA,qBAAA;AACF;;AAEA;EACE,oBAAA;EACA,0BAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;;;;EAIE,gCAAA;AACF;;AAEA;EACE,gCAAA;AACF","sourcesContent":[".list-item {\n  cursor: pointer;\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-110);\n  padding: 12px 24px;\n  display: flex;\n  align-items: center;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.header-title {\n  position: relative;\n  flex: 1;\n}\n\n.header-title:after {\n  position: absolute;\n  content: '';\n  width: 1px;\n  height: 32px;\n  inset-inline-end: 0px;\n  top: 50%;\n  margin-top: -16px;\n  background-color: var(--base-20);\n}\n\n.header-counter {\n  margin-inline-start: 8px;\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  color: var(--base-80);\n}\n\n.header-icon {\n  fill: var(--base-80);\n  transform: rotateX(180deg);\n}\n\n.header-opened-icon {\n  transform: rotateX(0deg);\n}\n\n.checkbox {\n  margin-inline-end: 24px;\n}\n\n.header:hover,\n.header:focus-visible,\n.list-item:hover,\n.list-item:focus-visible {\n  background-color: var(--base-17);\n}\n\n.header:active .list-item:active {\n  background-color: var(--base-20);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list-item": `SupportedMediaTypes__list-item-b9a7ec`,
	"listItem": `SupportedMediaTypes__list-item-b9a7ec`,
	"header": `SupportedMediaTypes__header-c02235`,
	"header-title": `SupportedMediaTypes__header-title-e9120e`,
	"headerTitle": `SupportedMediaTypes__header-title-e9120e`,
	"header-counter": `SupportedMediaTypes__header-counter-d84e70`,
	"headerCounter": `SupportedMediaTypes__header-counter-d84e70`,
	"header-icon": `SupportedMediaTypes__header-icon-fbcce9`,
	"headerIcon": `SupportedMediaTypes__header-icon-fbcce9`,
	"header-opened-icon": `SupportedMediaTypes__header-opened-icon-b9b769`,
	"headerOpenedIcon": `SupportedMediaTypes__header-opened-icon-b9b769`,
	"checkbox": `SupportedMediaTypes__checkbox-b9ed8c`
};
module.exports = ___CSS_LOADER_EXPORT___;
